/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_5Inputs */

const en_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export broadcast dialogue lists`)
};

const fr_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de listes de dialogues de diffusion`)
};

const de_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sendedialoglisten exportieren`)
};

const it_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione degli elenchi dei dialoghi trasmessi`)
};

const ru_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт списков диалогов для трансляции`)
};

const es_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar listas de diálogos de transmisión`)
};

const zh_cn2_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出广播对话列表`)
};

const ja_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放送セリフリストをエクスポート`)
};

const hi_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारण संवाद सूचियों को निर्यात करें`)
};

const pt_pt2_signup_feature_starter_5 = /** @type {(inputs: Signup_Feature_Starter_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listas de diálogo para transmissão de exportação`)
};

/**
* | output |
* | --- |
* | "Export broadcast dialogue lists" |
*
* @param {Signup_Feature_Starter_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_5 = /** @type {((inputs?: Signup_Feature_Starter_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_5(inputs)
	if (locale === "de") return de_signup_feature_starter_5(inputs)
	if (locale === "it") return it_signup_feature_starter_5(inputs)
	if (locale === "ru") return ru_signup_feature_starter_5(inputs)
	if (locale === "es") return es_signup_feature_starter_5(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_5(inputs)
	if (locale === "ja") return ja_signup_feature_starter_5(inputs)
	if (locale === "hi") return hi_signup_feature_starter_5(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_5(inputs)
	return en_signup_feature_starter_5(inputs)
});